import React, { Component, memo } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styled from 'styled-components'

const OuterWrapper = styled.div`
  ${({ width, height }) => ({ width, height })};
  box-sizing: content-box;
  padding: 3rem 4rem 0;
`

const InnerWrapper = styled.div`
  position: relative;
`

class TopicLayout extends Component {
  static propTypes = {
    topics: PropTypes.array.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    width: PropTypes.number,
    laneHeight: PropTypes.number,
    laneGap: PropTypes.number,
  }

  static defaultProps = {
    width: 400,
    laneHeight: 48,
    laneGap: 32,
  }

  render() {
    const {
      min,
      max,
      topics,
      width,
      laneHeight,
      laneGap,
      children,
    } = this.props

    // Organize topics in lanes
    const items = _.sortBy(topics, 'start')
    const lanes = []
    for (let i = 0; i < items.length; i++) {
      let j = 0
      while (lanes[j] && _.last(lanes[j]).end > items[i].start) j += 1
      if (!lanes[j]) lanes[j] = [items[i]]
      else lanes[j].push(items[i])
    }

    // Calculate layout
    const duration = max - min
    const unit = (1 / duration) * 100
    const nodes = _.flatten(
      lanes.map((lane, i, a) =>
        lane.map(d => {
          const { start, end } = d
          const percX = ((end - start) / duration) * 100
          const x = ((start - min) / duration) * 100
          const xPos = Math.round((x / 100) * width)
          const yPos = Math.round((a.length - i - 1) * (laneHeight + laneGap))
          return {
            data: d,
            xPos,
            yPos,
            width: percX + '%',
            widthAbs: (width * percX) / 100,
            height: laneHeight,
            unit,
          }
        })
      )
    )

    return (
      <OuterWrapper
        width={width}
        height={lanes.length * laneHeight + (lanes.length - 1) * laneGap}
      >
        <InnerWrapper>{_.isFunction(children) && children(nodes)}</InnerWrapper>
      </OuterWrapper>
    )
  }
}

export default memo(TopicLayout)
